import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import ModelLogo from './ModelLogo';

function CustomDropdown({
  value,
  onChange,
  type,
  placeholder,
  options,
  className = '',
  dropdownClassName = ''  // NEW: Allow custom width for dropdown content
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedOption = options.find(opt => opt.value === value);
  const displayText = selectedOption?.label || placeholder;
  const displayIcon = selectedOption?.icon;

  return (
    <div ref={dropdownRef} className={`relative h-10 ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="h-full px-4 border border-gray-200 rounded-xl bg-white text-sm font-medium text-gray-700 hover:border-gray-300 focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-50 transition-colors w-full flex items-center"
      >
        {/* Left side - icon and text */}
        <span className="flex items-center space-x-2 flex-1 min-w-0">
          {displayIcon && (
            typeof displayIcon === 'string'
              ? <span className="flex-shrink-0">{displayIcon}</span>
              : <span className="flex items-center flex-shrink-0">{displayIcon}</span>
          )}
          <span className="truncate">{displayText}</span>
        </span>

        {/* Right side - chevron (vertically centered) */}
        <ChevronDown
          size={16}
          className={`ml-2 flex-shrink-0 text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>

      {isOpen && (
        <div className={`absolute z-50 mt-1 bg-white border border-gray-200 rounded-xl shadow-lg max-h-64 overflow-y-auto ${dropdownClassName || 'w-full'}`}>
          {options.map((option) => (
            <button
              key={option.value}
              onClick={() => {
                onChange(option.value);
                setIsOpen(false);
              }}
              className={`w-full px-4 py-2.5 text-left text-sm hover:bg-gray-50 transition-colors flex items-center space-x-2 first:rounded-t-xl last:rounded-b-xl ${
                value === option.value ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700'
              }`}
            >
              {option.icon && (
                typeof option.icon === 'string'
                  ? <span className="flex-shrink-0">{option.icon}</span>
                  : <span className="flex items-center flex-shrink-0">{option.icon}</span>
              )}
              {option.model ? (
                <div className="flex items-center space-x-2 flex-1 min-w-0">
                  <ModelLogo model={option.model} size="sm" />
                  <span className="truncate">{option.label}</span>
                </div>
              ) : (
                <span className="truncate">{option.label}</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default CustomDropdown;